import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import Grid                                     from '@material-ui/core/Grid'
import HistoryCitationReadComponent             from './HistoryCitationReadComponent'
import { node_server }                          from '../Helpers'
import Typography                               from '@material-ui/core/Typography'

const HistoryCitationUpdateComponent = () => {

   const [ id,                                  setId                            ]  =  useState('')

   const handleSelect = (id) => {
      setId(id)
   }

   useEffect( () => {
      console.log('History Citation Update Component useEffect is running')
      if (id !== '') {
         axios.get(node_server + `guestBio/${id}`)
            .then( res => res.data )
            .then( data => {
               if (data.msg === 'good_operation') {
                  // setGuestBio(data.guestBio)
               }
               else {
                  throw new Error('bad_operation_get_gb2')
               }
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
   }, [id] )

   return(
      <Box style={{ marginTop: '6rem', marginBottom: '1rem', padding: '2rem' }} >
         <Grid>
            <Typography variant='h4'>
               History Citation Update Page
            </Typography>
         </Grid>
         <Grid>
            { id === '' ? <HistoryCitationReadComponent handleSelect={handleSelect} page={'history_citation_update'} /> : null }
         </Grid>
      </Box>
   )
}

export default HistoryCitationUpdateComponent
